import React, { useEffect, useRef, useState } from "react";
import { apiFetch } from "../../helpers/api";
import "./CoachesAndSporters.css";
import { useTranslation } from "react-i18next";
import ProfileModal from "./ProfileModal";

const Sporters = () => {
  const [sporters, setSporters] = useState([]);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const scrollContainerRef = useRef(null);
  const [selectedSporter, setSelectedSporter] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    fetchSporters();
  }, []);

  useEffect(() => {
    const el = scrollContainerRef.current;

    const updateScrollState = () => {
      if (!el) {
        setCanScrollLeft(false);
        setCanScrollRight(false);
        return;
      }

      const maxScrollLeft = el.scrollWidth - el.clientWidth;
      const hasOverflow = maxScrollLeft > 1;

      setCanScrollLeft(hasOverflow && el.scrollLeft > 1);
      setCanScrollRight(hasOverflow && el.scrollLeft < maxScrollLeft - 1);
    };

    updateScrollState();
    el?.addEventListener("scroll", updateScrollState, { passive: true });
    window.addEventListener("resize", updateScrollState);

    return () => {
      el?.removeEventListener("scroll", updateScrollState);
      window.removeEventListener("resize", updateScrollState);
    };
  }, [sporters]);

  const fetchSporters = async () => {
    try {
      const data = await apiFetch("/api/sporters");
      setSporters(data);
    } catch (err) {
      console.error("Failed to fetch sporters:", err);
    }
  };

  const scrollLeft = () => {
    scrollContainerRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollContainerRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  const hasProfileData = (sporter) => Boolean(
    sporter.profileTitle || sporter.biography || sporter.achievements?.length
  );

  return (
    <section className="about-sporters-coaches">
      <h3>{t("aboutUs.sporters")}</h3>

      <div className="carousel-wrapper">
        {canScrollLeft && (
          <button
            className="scroll-button left"
            onClick={scrollLeft}
            aria-label="Previous athlete"
          >
            &#10094;
          </button>
        )}
        <div className="carousel" ref={scrollContainerRef}>
          {sporters.map((sporter, index) => (
            <button
              className="card profile-card"
              type="button"
              key={sporter.id || index}
              onClick={() => hasProfileData(sporter) && setSelectedSporter(sporter)}
              disabled={!hasProfileData(sporter)}
            >
              <div className="card-image">
                <img src={sporter.imageUrl} alt={sporter.name} />
                {hasProfileData(sporter) && <span className="profile-card__hover"><strong>{sporter.biography || sporter.profileTitle}</strong><em>Visit profile →</em></span>}
              </div>
              <div className="card-info">
                <h4>
                    {sporter.name} {sporter.surname}
                </h4>

                {sporter.description && (
                  <p className="description">{sporter.description}</p>
                )}
              </div>
            </button>
          ))}
        </div>
        {canScrollRight && (
          <button
            className="scroll-button right"
            onClick={scrollRight}
            aria-label="Next athlete"
          >
            &#10095;
          </button>
        )}
      </div>
      <ProfileModal profile={selectedSporter} type="sporter" onClose={() => setSelectedSporter(null)} />
    </section>
  );
};

export default Sporters;
